// A list of ticks (a multiselect question's answer options) in columns: which
// options take the whole width of the list. Both ways of filling in a rider's
// questions use it, so they cannot drift apart: the widget's checkout
// (QuestionControl, .vt-q-options) and the admin pay-link page
// (/pay/[token]). Layout only: the options, their words and their order are
// the tenant's, exactly as configured.
//
// Pure: no React, no DOM. Pinned by e2e/question-layout.spec.ts.

/** An option longer than this many characters counts as long. */
export const WIDE_OPTION_CHARS = 32;

/**
 * Per option (in its order): does it take the whole row of its list? A long
 * option ("I am not currently confident with any of the above") would wrap
 * into a tall, ragged block in a narrow column, so it spans the row, but only
 * when every option after it is long too (the list's last options). A long
 * option in the middle of the list stays in its column and wraps there: were
 * it to span, the short option before it would sit alone on its row and the
 * list would show gaps (the options keep their order, so nothing may move up
 * into a gap, and the keyboard's order stays the reading order).
 */
export function wideOptions(options: readonly string[]): boolean[] {
  const out = options.map(() => false);
  for (let i = options.length - 1; i >= 0 && options[i]!.trim().length > WIDE_OPTION_CHARS; i--) out[i] = true;
  return out;
}
